module Elma.ViewModels {

    export class Html5VideoViewModel  {

        public figureContainer = ko.observable<HTMLElement>();
        public isVisible = ko.observable(false);
        public isHidden = ko.observable(true);
        public elementSelector = ko.observable<string>();

        constructor() {
            this.elementSelector.subscribe((newSelector) => {
                this.figureContainer(<HTMLElement>document.getElementById(newSelector));
            });    
        }
		
        public toggleCoverImage = (() => {
            this.figureContainer().style.display = "none";
            this.isVisible(true);
            this.isHidden(false);
        });
    }   
}